const BonusCompliance = () =>
    import("@/views/bonusCompliance/BonusCompliance");

const BonusComplianceList = () =>
    import("@/views/bonusCompliance/BonusComplianceList");

const LiquidationQuery = () =>
    import("@/views/bonusCompliance/LiquidationQuery");

const PreliquidationGeneration = () =>
    import("@/views/bonusCompliance/PreliquidationGeneration");

const PreliquidationApproval = () =>
    import("@/views/bonusCompliance/PreliquidationApproval");

export const BonusComplianceListRoute = {
    path: "bonusComplianceList",
    component: BonusComplianceList,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",      
        breadcrumb: [
            {
                text: "Bonos por Cumplimiento",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const LiquidationQueryRoute = {
    path: "liquidationQuery",
    component: LiquidationQuery,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta de liquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationGenerationRoute = {
    path: "preliquidationGeneration",
    component: PreliquidationGeneration,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Generacion de preliquidación",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationApprovalRoute = {
    path: "preliquidationApproval",
    component: PreliquidationApproval,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",  
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Aprobación de preliquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};


export const BonusComplianceRoute = {
    path: "bonusCompliance",
    component: BonusCompliance,
    children: [

        BonusComplianceListRoute,
        LiquidationQueryRoute,
        PreliquidationGenerationRoute,
        PreliquidationApprovalRoute,
    ]
}